import {get} from 'utils/axios/index'
import {AxiosError} from 'axios'
import {
 handleRejectedErrorMsg,
 showErrorMsg,
} from 'utils/helpers/handleError'
import {IUserDetails} from 'models/Auth'

const fetchUserDetails = async (user_id?: string) => {
 try {
  return await (
   await get
  )<IUserDetails>('/users/v1/details', {user_id}).then(
   (res) => {
    if (res) {
     return res
    } else {
     showErrorMsg('Something went wrong')
     return null
    }
   }
  )
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

export {fetchUserDetails}
